/* eslint-disable import/order */
import React from 'react';
import PropTypes from 'prop-types';
import { IoMdClose } from 'react-icons/io';
import { useTranslation } from 'react-i18next';

import { ROUTES } from 'utils/constants';
import { handleTrackEvent } from '../utils/handleTrackEvent';
import { usePaywallExit } from '../utils/usePaywallExit';
import check from 'assets/images/evie-check-1.svg';
import topknot from 'assets/images/evie-topknot.svg';
import bell from 'assets/images/evie-bell.svg';
import star from 'assets/images/evie-star.svg';

import SolidButton from 'components/SolidButton';
import ExitOfferModal from 'components/evieApp/ExitOfferModal';

import { useGetParams } from '../utils/useGetParams';
import { formatPriceWithCode } from '../utils/helpers';

const TrialScreen = ({ selectedOffer }) => {
  const { t } = useTranslation();
  const { push, planStep, urlParams } = useGetParams();
  const { isExitModalOpen, handleGoBack, handleAcceptFreeTier, handleDismissModal } = usePaywallExit({
    screen: 'trial',
  });

  const price = selectedOffer
    ? formatPriceWithCode(
        selectedOffer.rcBillingProduct.currentPrice.amount,
        selectedOffer.rcBillingProduct.currentPrice.currency,
      )
    : '';

  const handleNext = () => {
    handleTrackEvent('Step plan', { number: planStep + 1 });
    const searchParams = new URLSearchParams(urlParams);
    searchParams.set('plan_step', String(planStep + 1));
    push(`${ROUTES.EVIE_ONBOARDING}?${searchParams.toString()}`);
  };

  return (
    <>
      <div className="trial-screen">
        <div className="trial-screen__goback">
          <IoMdClose className="trial-screen__goback_icon" onClick={handleGoBack} />
        </div>
        <section className="trial-screen__header">
          <div className="trial-screen__header_bg" />
          <h2 className="trial-screen__header_title">{t('evieOnboarding.trialScreen.title')}</h2>
        </section>
        <section className="trial-screen__content">
          <div className="trial-screen__steps firstchild">
            <section className="trial-screen__icons firstchild">
              <span className="trial-screen__icons_progress" />
              <img src={check} alt="check icon" />
            </section>
            <section className="trial-screen__contentsteps">
              <p className="trial-screen__contentsteps_title firstchild">
                {t('evieOnboarding.trialScreen.steps.stepOne.title')}
              </p>
              <p className="trial-screen__contentsteps_content">
                {t('evieOnboarding.trialScreen.steps.stepOne.content')}
              </p>
            </section>
          </div>
          <div className="trial-screen__steps">
            <section className="trial-screen__icons">
              <span className="trial-screen__icons_progress" />
              <img src={topknot} alt="topknot icon" />
            </section>
            <section className="trial-screen__contentsteps secondchild">
              <p className="trial-screen__contentsteps_title">{t('evieOnboarding.trialScreen.steps.stepTwo.title')}</p>
              <p className="trial-screen__contentsteps_content">
                {t('evieOnboarding.trialScreen.steps.stepTwo.content')}
              </p>
            </section>
          </div>
          <div className="trial-screen__steps">
            <section className="trial-screen__icons">
              <img src={bell} alt="bell icon" />
            </section>
            <section className="trial-screen__contentsteps">
              <p className="trial-screen__contentsteps_title">
                {t('evieOnboarding.trialScreen.steps.stepThree.title')}
              </p>
              <p className="trial-screen__contentsteps_content">
                {t('evieOnboarding.trialScreen.steps.stepThree.content')}
              </p>
            </section>
          </div>
          <div className="trial-screen__steps">
            <section className="trial-screen__icons">
              <img src={star} alt="star icon" />
            </section>
            <section className="trial-screen__contentsteps">
              <p className="trial-screen__contentsteps_title">{t('evieOnboarding.trialScreen.steps.stepFour.title')}</p>
              <p className="trial-screen__contentsteps_content">
                {selectedOffer ? t('evieOnboarding.trialScreen.steps.stepFour.content', { price }) : ''}
              </p>
            </section>
          </div>
        </section>
        <section className="trial-screen__footer">
          <SolidButton className="evie-survey" onClick={handleNext}>
            {t('evieOnboarding.trialScreen.button')}
          </SolidButton>
          <p className="trial-screen__footer_faq">{t('evieOnboarding.trialScreen.cancelFaq')}</p>
        </section>
      </div>
      <ExitOfferModal
        modalIsOpen={isExitModalOpen}
        onAcceptFreeTier={handleAcceptFreeTier}
        onDismiss={handleDismissModal}
      />
    </>
  );
};

TrialScreen.defaultProps = {
  selectedOffer: null,
};

TrialScreen.propTypes = {
  selectedOffer: PropTypes.shape({
    identifier: PropTypes.string.isRequired,
    rcBillingProduct: PropTypes.shape({
      currentPrice: PropTypes.shape({
        currency: PropTypes.string.isRequired,
        amount: PropTypes.number.isRequired,
      }).isRequired,
    }).isRequired,
  }),
};

export default TrialScreen;
